import React from "react";
import { Button, useNotify, useRefresh } from "react-admin";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import dataProvider from "server/dataProvider";
import DeleteIcon from "@mui/icons-material/Delete";
import { graduationRequests } from "api/graduationApi";

const DeleteStudentDialog = ({ cycleId, studentEducationId }) => {
  const refresh = useRefresh();
  const notify = useNotify();

  const handleSubmit = async () => {
    await dataProvider.customRequest(
      graduationRequests.removeStudentFromIndividualCycle(cycleId, studentEducationId),
      null,
      "PUT",
    );
    refresh();
    notify("Успешно премахнат студент от часови интервал", { type: "success" });
  };

  return (
    <ConfirmModal
      onConfirm={handleSubmit}
      titleContent="Премахване на студент от часови интервал"
      triggerButton={
        <Button
          label="Премахни"
          startIcon={<DeleteIcon />}
          color="error"
          size="small"
        />
      }
      message="Сигурни ли сте, че искате да премахнете студента от този часови интервал?"
    />
  );
};

export default DeleteStudentDialog;
